module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-right-088ccbb58f365544ecf59fd2753ea1c4.svg";